import React from "react";
import { assetImg } from "@/modules/moduleImporter";
import { langLiteralType } from "@/modules/locales";

interface IProps {
    // The current language
    langStr: langLiteralType;
    updateLanguage: (e: any) => void;

    // Desktop header only
    smallButton?: boolean;
}

interface IState {
	active: boolean;
}

// Usage: Desktop lobby, Settings, mobile lobby
export default class LanguagePicker extends React.Component<IProps, IState> {
    state = {active: false};

	shouldComponentUpdate(nextProps: IProps, nextState: IState) {
		return (
			this.state.active !== nextState.active ||
			this.props.langStr !== nextProps.langStr
		);
	}

    toggleActivation() {
        this.setState({active: !this.state.active});
    }

    clickSmallButton(e: React.MouseEvent) {
        this.props.updateLanguage(e);
        this.toggleActivation();
    }

    render() {
        const prop = { prop: "language" };

        const languages = {
            "en": "English",
            "id": "Bhs. Indonesia",
            "th": "ภาษาไทย",
            "vn": "Tiếng việt",
            "cn": "中文"
        };

        return (
            this.props.smallButton ? (
                <div className="tip lang-small">
                    <button onClick={this.toggleActivation.bind(this)}>
                        {assetImg("lang", this.props.langStr)}
                    </button>
                    
                    {
                        this.state.active ?
                        <div>
                            {
                                Object.keys(languages).map(item => 
                                    <button key={"lang_" + item}
                                        onClick={this.clickSmallButton.bind(this)}
                                        value={item}
                                        disabled={this.props.langStr === item}>

                                        {assetImg("lang", item)}
                                    </button>
                                )
                            }
                        </div>
                        : null
                    }
                </div>
            ) : (
                <select value={this.props.langStr}
                    onChange={this.props.updateLanguage}>
                {
                    Object.keys(languages).map(item => 
                        <option key={"lang_" + item}
                            {...{prop}}
                            value={item}>
                        
                            {languages[item]}
                        </option>
                    )
                }
                </select>
            )
        );
    }
}